// import SimilaritySearch from '../components/SimilaritySearch'
import XEUtils from "xe-utils";
import httpManager from "../../util/common";

let similarity_search = {
  components: {},
  data: () => {
    return {
      search_oaid: null,
      total_min: null,
      total_max: null,
      similarity_min: null,
      similarity_max: null,
      company_total: 0,
      company_select: 'all',
      sort_column: 'ipc_total',
      sort_order: 'desc',
      data: [],
      loading: false,
      company_select_options: [
        {label: '全部公司', value: 'all'},
        {label: '上市公司', value: 'listed_company'}
      ],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      }
    }
  },
  methods: {
    headerCellClickEvent ({ column, triggerResizable, triggerSort, triggerFilter }) {
      // 如果触发了列的其他功能按钮
      if (column.sortable && !(triggerResizable || triggerSort || triggerFilter)) {
        this.sort_column = column.property
        this.sort_order = column.order
        // $refs.xTable.sort('name', 'desc')
        this.getSimilaritySearchTableData()
      } else if (column.sortable && triggerSort) {
        this.sort_column = column.property
        if (this.sort_order === 'desc') {
          this.sort_order = 'asc'
          column.order = 'asc'
        } else {
          this.sort_order = 'desc'
          column.order = 'desc'
        }
        this.getSimilaritySearchTableData()
      }
    },
    searchSimilarityData () {
      this.getSimilaritySearchTableData()
    },
    searchSimilarityKeyUp (e) {
      if (e.$event.key === 'Enter') {
        this.getSimilaritySearchTableData()
      }
    },
    clearData () {
      this.data = []
      this.page.pageSize = 20
      this.page.currentPage = 1
      this.page.total = 0
      this.total_min = null
      this.total_max = null
      this.similarity_min = null
      this.similarity_max = null
    },
    cellClickEvent ({row, column}) {
      if (column.property === 'entname') {
        const {
          href
        } = this.$router.resolve({path: '/entity/' + row.company_oaid + '/patent/detail'})
        window.open(href, '_blank')
      }
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getSimilaritySearchTableData()
    },
    getStatisticsData () {
      let self = this
      if (self.search_oaid) {
        let params = new Map()
        params.set('oaid', self.search_oaid)
        httpManager('technique_field_search', params, null, null, null)
          .then(response => {
            if (response.data.data.length > 0) {
              self.company_total = response.data.data[0]['total']
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    getSimilaritySearchTableData () {
      let self = this
      if (self.search_oaid) {
        self.loading = true
        let params = new Map()
        params.set('pagenum', self.page.currentPage)
        params.set('pagesize', self.page.pageSize)
        params.set('search_oaid', self.search_oaid)
        params.set('sort_column', self.sort_column)
        params.set('sort_order', self.sort_order)
        params.set('company_select', self.company_select)
        if (self.total_min) {
          params.set('total_min', self.total_min)
        }
        if (self.total_max) {
          params.set('total_max', self.total_max)
        }
        if (self.similarity_min) {
          params.set('similarity_min', self.similarity_min)
        }
        if (self.similarity_max) {
          params.set('similarity_max', self.similarity_max)
        }
        httpManager('similarity_search', params, null, null, null)
          .then(response => {
            self.data = response.data.data
            let page = response.data.page
            self.page.total = page.total
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
      }
    }
  },
  watch: {
    search_oaid: function () {
      this.page.currentPage = 1
      this.company_total = 0
      this.getStatisticsData()
      this.getSimilaritySearchTableData()
    },
    company_select: function () {
      this.page.currentPage = 1
      this.getSimilaritySearchTableData()
    }
  },
  computed: {
    tableColumn() {
      return [
        {type: 'seq', width: 50},
        {title: this.$t('patent.company_insitution_name'), field: 'entname', className: 'click-cell-style'},
        {title: this.$t('patent.security_code'), field: 'ticker'},
        {title: this.$t('patent.patent_number'), field: 'ipc_total', sortable: true, formatter: ({cellValue}) => {
          return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 0})}` : ''}},
        {title: this.$t('patent.similarity'), field: 'ipc_similarity', sortable: true, formatter: ({cellValue}) => {
          return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 4})}` : ''}}
      ]
    }
  }
}
export default similarity_search



// WEBPACK FOOTER //
// ./src/patent/js/similarity_search.js